/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
  PhoneInput,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneMusic } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const music = getOneMusic();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const music_id = music?.music_id;
  const [thumbnail, setThumbnail] = useState(music?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(music?.image_cdn_id);
  const [title, setTitle] = useState(music?.title);
  const [hashtags, setHashtags] = useState(music?.hashtag);
  const [eventStatus, setEventStatus] = useState(music?.status);
  const [description, setDescription] = useState(music?.description);
  const [repeatEvery, setRepeatEvery] = useState(music?.repeat_every);
  const [expo, setExpo] = useState(music?.expo);
  const [pricing, setPricing] = useState(music?.Pricings);
  const [venue, setVenue] = useState(music?.venue);
  const [startDate, setStartDate] = useState(music?.start_date);
  const [endDate, setEndDate] = useState(music?.end_date);
  const [startTime, setStartTime] = useState(music?.start_time);
  const [endTime, setEndTime] = useState(music?.end_time);
  const [venueCapacity, setVenueCapacity] = useState(music?.venue_capacity);
  const [email, setEmail] = useState(music?.email_address);
  const [payLink, setPayLink] = useState(music?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(music?.phone_number);
  const [whatsapp, setWhatsapp] = useState(music?.whatsapp);
  const [facebook, setFacebook] = useState(music?.facebook);
  const [twitter, setTwitter] = useState(music?.twitter);
  const [instagram, setInstagram] = useState(music?.instagram);
  const [youtube, setYoutube] = useState(music?.youtube);
  const [googleMapCode, setGoogleMapCode] = useState(music?.google_map_code);
  const [latitude, setLatitude] = useState(music?.latitude);
  const [longitude, setLongitude] = useState(music?.longitude);
  const [formattedAddress, setFormattedAddress] = useState(
    music?.formatted_address
  );
  const [featured, setFeatured] = useState(music?.featured);
  const [promoted, setPromoted] = useState(
    music?.promoted ? music?.promoted : "no"
  );
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const musicRoutes = "/data/music";

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : music?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      hashtag: hashtags,
      status: eventStatus,
      repeat_every: repeatEvery,
      expo: expo,
      pricing: pricing,
      venue: venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      venue_capacity: venueCapacity,
      end_time: endTime,
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      featured: featured,
      promoted: promoted,
    };

    const { message, status } = await updateOneContent({
      data_id: music_id,
      data: data,
      content: _TYPES_.MUSIC,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  // compact design tokens (kept minimal)
  const container = "max-w-7xl mx-auto px-4 sm:px-5";
  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-3 sm:p-4"; // compact padding
  const sectionTitle = "text-sm font-semibold text-slate-900";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4`}>
        <div className="mb-2">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: musicRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `Edit Music`, name: entry_label }} />
        </div>

        <form onSubmit={updateOneEventHandler} className="space-y-3">
          <div className={`${card} ${sectionPad}`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Cover Image" }} />
            <div className="mt-2">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.MUSIC)}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Concert Details" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  required: true,
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue",
                  title: "Venue",
                  type: "text",
                  value: venue ? venue : "",
                  onChange: (e) => {
                    setVenue(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue_capacity",
                  title: "Venue Capacity",
                  type: "number",
                  value: venueCapacity ? venueCapacity : "",
                  onChange: (e) => {
                    setVenueCapacity(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress ? formattedAddress : "",
                  onChange: (e) => {
                    setFormattedAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <p className={sectionTitle}>Pricing</p>
            <div className="mt-2">
              <Pricing pricing={pricing} setPricing={setPricing} />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <p className={sectionTitle}>Repeat Every</p>
            <div className="mt-2 flex flex-wrap gap-4 text-sm">
              {[
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
                "annual",
              ].map((val) => (
                <div key={val} className="flex items-center gap-2 capitalize">
                  <span className="min-w-[72px]">{val}</span>
                  {repeatEvery?.toString().split("|").includes(val) ? (
                    <MdCheckBox
                      onClick={() => {
                        let rep = "";
                        repeatEvery
                          ?.split("|")
                          .filter((day) => val !== day)
                          .map((weekday) => (rep += `${weekday}|`));
                        setRepeatEvery(rep);
                      }}
                      className="text-xl cursor-pointer"
                    />
                  ) : (
                    <MdCheckBoxOutlineBlank
                      onClick={() => {
                        let rep = "";
                        if (repeatEvery) {
                          [...repeatEvery.split("|"), val].map(
                            (weekday) => (rep += `${weekday}|`)
                          );
                          setRepeatEvery(rep);
                        } else {
                          setRepeatEvery(val);
                        }
                      }}
                      className="text-xl cursor-pointer"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Date & Time" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
              <InputField
                props={{
                  id: "start_date",
                  title: "Start Date",
                  type: "date",
                  value: startDate ? startDate : "",
                  onChange: (e) => {
                    setStartDate(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "end_date",
                  title: "End Date",
                  type: "date",
                  value: endDate ? endDate : "",
                  onChange: (e) => {
                    setEndDate(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "start_time",
                  title: "Start Time",
                  type: "time",
                  value: startTime ? startTime : "",
                  onChange: (e) => {
                    setStartTime(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "end_time",
                  title: "End Time",
                  type: "time",
                  value: endTime ? endTime : "",
                  onChange: (e) => {
                    setEndTime(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              <div className="flex justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode ? googleMapCode : "",
                  onChange: (e) => {
                    setGoogleMapCode(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude ? latitude : "",
                  onChange: (e) => {
                    setLatitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude ? longitude : "",
                  onChange: (e) => {
                    setLongitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              <Select
                props={{
                  id: "event_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  preselect:
                    eventStatus !== null
                      ? [{ name: eventStatus === 1 ? "visible" : "invisible" }]
                      : null,
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setEventStatus(1);
                    else setEventStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  preselect: featured !== null ? [{ name: featured }] : null,
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  preselect: promoted !== null ? [{ name: promoted }] : null,
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  preselect:
                    expo !== null
                      ? [{ name: expo === 0 ? "no" : "yes" }]
                      : null,
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-between">
              <Title props={{ title: "Description" }} />
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className="bg-blue-700 text-white px-3 py-2 rounded-lg hover:bg-blue-600"
              >
                Generate Description
              </MyButton>
            </div>
            <div className="mt-2">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className="flex justify-end">
            <MyActionButton
              loading={loading}
              title="Save Changes"
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </form>
      </div>

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Edit;
